import routes from '../routes'
import vue from 'vue'
import {
    filterResponse,
    filterErrors
} from '../client'

export const getBankList = () => {
    return vue.http.get( routes.sendMoney.bankList ).then( filterResponse )
        .catch( e => {
            return filterErrors( e )
        } )
}
export const getRecent = () => {
    return vue.http.get( routes.sendMoney.recent ).then( filterResponse )
        .catch( e => {
            return filterErrors( e )
        } )
}
export const getWalletRecent = () => {
    return vue.http.get( routes.sendMoney.walletRecent ).then( filterResponse )
        .catch( e => {
            return filterErrors( e )
        } )
}


export const getSaved = () => {
    return vue.http.get( routes.sendMoney.saved ).then( filterResponse )
        .catch( e => {
            return filterErrors( e )
        } )
}
export const getRecurring = () => {
    return vue.http.get( routes.sendMoney.recurring ).then( filterResponse )
        .catch( e => {
            return filterErrors( e )
        } )
}

export const getHistory = () => {
    return vue.http.get( routes.sendMoney.history ).then( filterResponse )
        .catch( e => {
            return filterErrors( e )
        } )
}

export const postInterTransfer = ( data ) => {
    data.channel = 'web';
    return vue.http.post( routes.sendMoney.interTransfer, data ).then( filterResponse )
        .catch( e => {
            return filterErrors( e )
        } )
}

export const postCustomerLookup = ( data ) => {
    return vue.http.post( routes.sendMoney.customerLookup, data ).then( filterResponse )
        .catch( e => {
            return filterErrors( e )
        } )
}

export const postFoundTransfer = ( data ) => {
    data.authorizationCode = Date.now() + '_' + data.client.id;
    data.channel= 'web';
    return vue.http.post( routes.sendMoney.fundTransfer, data ).then( filterResponse )
        .catch( e => {
            return filterErrors( e )
        } )
}

export const getBankAccountLookup = ( bankId, accountNumber ) => {
    return vue.http.get( routes.sendMoney.bankAccountLookup + `${bankId}/${accountNumber}` ).then( filterResponse )
        .catch( e => {
            return filterErrors( e )
        } )
}
export const getServiceCharge = ( bankCode, clientId, amount ) => {
    return vue.http.get( routes.sendMoney.serviceCharge + `bankCode=${bankCode}&clientId=${clientId}&transferAmount=${amount}` ).then( filterResponse )
        .catch( e => {
            return filterErrors( e )
        } )
}

export const getTransactionStatus = (transactionId) => {
    return vue.http.get(routes.sendMoney.transactionStatus + transactionId).then(filterResponse)
        .catch(e => {
            return filterErrors(e)
        })
}

export const updateRecurring = (id,data) => {
    data.authorizationCode = Date.now() + '_' + data.client.id;
    data.channel= 'web';

    return vue.http.put(routes.sendMoney.updateRecurring + id, data).then(filterResponse)
        .catch(e => {
            return filterErrors(e)
        })
}
export const deleteSaved = (id) => {
    return vue.http.delete(routes.sendMoney.deleteSaved + id).then(filterResponse)
        .catch(e => {
            return filterErrors(e)
        })
}
export const deleteRecurringSendMoney = (id) => {
    return vue.http.delete(routes.sendMoney.deleteRecurring + id).then(filterResponse)
        .catch(e => {
            return filterErrors(e)
        })
}